module.exports = __webpack_public_path__ + "static/img/get.6baa1c05.jpg";